import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    this.element.style.transition = "opacity 0.2s ease-out"
    this.element.style.opacity = "0"
    setTimeout(() => {
      // Replace content with empty turbo frame to reset for next trigger
      this.element.innerHTML = ""
      this.element.style.opacity = "1"
      this.element.style.transition = ""
    }, 200)
  }
}
